import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import "./TextColumn.scss"

const TextColumn = ({ title, leftText, rightText }) => {
  return (
    <div className="container text-column-container my-3 my-md-5">
      {title && (
        <h2 className=" text-column-title text-uppercase">
          {title}
        </h2>
      )}

      <div className="row">
        <div className="col-md-6">
          <ReactMarkdown className="text-column-markdowon-format">{leftText}</ReactMarkdown>
        </div>
        <div className="col-md-6">
          <ReactMarkdown className="text-column-markdowon-format">{rightText}</ReactMarkdown>
        </div>
      </div>
    </div>
  )
}

export default TextColumn

TextColumn.propTypes = {
  title: PropTypes.string,
  leftText: PropTypes.string.isRequired,
  rightText: PropTypes.string.isRequired
}
